var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",class:_vm.getClass(),attrs:{"type":_vm.type,"disabled":_vm.disabled ? true: false},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.title))])}
var staticRenderFns = []

export { render, staticRenderFns }